<template>
  <div :class="{ 'sso-form-disabled': disabled }">
    <DpplFormField
      v-for="(value, key) in form.values"
      :key="key"
      :field-name="key"
      :form="form"
      v-bind="$attrs"
    >
      <template #field="{ props, on }">
        <component
          :is="key === 'certificate' ? 'DpplTextArea' : 'DpplTextField'"
          :label="form.labels[key]"
          :disabled="disabled"
          :hint="form.labels[key]"
          :has-details="true"
          persistent-hint
          v-bind="props"
          v-on="on"
        >
          <template #message="{ message }">
            <div class="mb-4">
              <template v-if="message === 'Entity ID'">
                For example:
                <div>
                  <strong>
                    http://www.okta.com/exk1234567890aBcDeFg
                  </strong>
                </div>
                <div>
                  <strong>
                    https://sts.windows.net/12345678-abcd-abcd-abcd-1234567890ab/
                  </strong>
                </div>
              </template>

              <template v-else-if="message === 'SAML Location URL'">
                For example:
                <div>
                  <strong>
                    https://company.okta.com/app/__okta_app_id__/exk000.../sso/saml
                  </strong>
                </div>
                <div>
                  <strong>
                    https://login.microsoftonline.com/12345678-abcd-abcd-abcd-1234567890ab/saml2
                  </strong>
                </div>
              </template>

              <template v-else-if="message === 'Certificate'">
                Starts with <strong>MII...</strong>
                and may have some "<strong>=</strong>" signs at the end
              </template>

              <template v-else>
                {{ message }}
              </template>
            </div>
          </template>
        </component>
      </template>
    </DpplFormField>
  </div>
</template>

<script>
import DpplTextField from '@/components/datapeople/DpplTextField.vue';
import DpplTextArea from '@/components/datapeople/DpplTextArea.vue';
import DpplFormField from '@/components/datapeople/DpplFormField.vue';

export default {
  name: 'SsoSetupForm',
  components: { DpplFormField, DpplTextField, DpplTextArea },
  props: {
    form: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
  },
};
</script>

<style scoped lang="less">
.sso-form-disabled {
  opacity: 0.7;
}

:deep(textarea) {
  height: 80px;
}
</style>
